<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'RentalWarningModal',
  components: { DialogCloseButton, PopupModal },
  data() {
    return {
      loading: false,

      resolvePromise: undefined,
      rejectPromise: undefined
    }
  },
  methods: {
    show() {
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    async _confirm() {
    },
    async _reject() {
      this.$refs.popup.close()
    }
  }
}
</script>

<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="_reject" />

    <div>
      <h2 class="content-title mb-4">
        {{ $t('RENTAL_WARNING_MODAL.TITLE') }}
      </h2>

      <!--Information-->
      <div class="content-information">
        <div class="d-flex justify-space-between content-text-information">
          <p>{{ $t('RENTAL_WARNING_MODAL.MESSAGE') }}</p>
        </div>
      </div>
    </div>
  </popup-modal>
</template>

<style scoped>
.content-title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
}

.content-information {
  display: flex;
  flex-direction: column;
  align-self: stretch;
}

.content-text-information {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
